import { ReactSVG } from 'react-svg';
import React, { useContext, useEffect, useState } from 'react';

const MicRipple = (props) => {
	const micIcon = props.hasAudio ? 'mic_white' : 'mic_off-24px';

	return (
		<>
			<div
				id={props.streamId ? 'circle_' + props.streamId : ''}
				className={`center-circle relative h-16 w-16`}
				style={{ position: 'relative' }}
			>
				<div
					className="flex items-center justify-center w-full h-full rounded-full"
					style={{ background: '#1B2127' }}
				>
					<ReactSVG className={''} src={`../../../images/icons/${micIcon}.svg`} />
				</div>
			</div>
		</>
	);
};

export default MicRipple;
